import HBEmpty from "@/components/HBEmpty";
import HBIcon from "@/components/HBIcon";
import HBMessage from "@/components/HBMessage";
import Image from "@/components/Image";
import { useLogin } from "@/components/LoginModal";
import PinButton from "@/components/PinCard/actions/button";
import { PinEditorModal } from "@/components/PinEditor";
import ShareDropdown from "@/components/ShareDropdown";
import SimilarMaterialList from "@/components/SimilarMaterialList";
import { EVENT } from "@/constants/event";
import { deletePin, getPin, likePin, report, unlikePin } from "@/services";
import displayNum from "@/utils/displayNum";
import { ContentType, getContentType } from "@/utils/getContentType";
import imageUrl from "@/utils/imageUrl";
import isEditingElement from "@/utils/isEditingElement";
import useRequest from "@/utils/useReq";
import { useKeyPress, useMount } from "ahooks";
import { Affix, Button, Modal } from "antd";
import classNames from "classnames";
import { useRouter } from "next/router";
import qs from "qs";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Case, Else, If, Switch, Then, When } from "react-if";
import Board from "./Board";
import ModalOperate from "./ModalOperate";
import PinHead from "./PinHead";
import PinMaterial, { PinMaterialRedirect } from "./PinMaterial";
import User from "./User";
import styles from "./index.module.less";
// import PinMoreDropdown from "./PinMoreDropdown";
import { PIN_OPEN_TYPE } from "@/constants/pinOpenType";
import { SHORTCUT } from "@/constants/shortcut";
import { isBigCompanyByUser } from "@/constants/vip";
import useAppStore from "@/context/store";
import { addHistory } from "@/services/history";
import { getExpsValue } from "@/tracker/abTest";
import pvTracker from "@/tracker/report/pvTracker";
import getPageData from "@/tracker/shared/getPageData";
import getNextDetailsSetp, {
  getNextViewImageSetp,
} from "@/utils/getHistorySetp";
import { PRESETS_CONDITION, stewardInstance } from "@/utils/steward";
import ReportModal from "../ReportModal";
import UserGuideTooltip from "../UserGuideTooltip";
import PinAIInfo from "./PinAIInfo";
import PinTitle from "./PinTitle";
import Recommend from "./Recommend";
import PinTopic from "./Topic";
export default function PinDetail(props) {
  const router = useRouter();
  const {
    user,
    userReady,
    pinQueue,
    headerHeight,
    pinOpenType,
    currentPin = null,
    config,
  } = useAppStore(
    ({
      user,
      userReady,
      pinQueue,
      headerHeight,
      currentPin,
      pinOpenType,
      config,
    }) => ({
      user,
      userReady,
      pinQueue,
      headerHeight,
      currentPin,
      pinOpenType,
      config,
    })
  );
  const { login } = useLogin();
  const {
    pinId,
    pin: initPins,
    file,
    currentSrc,
    onClose,
    isModal,
    relatedBoards,
    similarMaterials,
  } = props;
  const [pin, setPin] = useState(initPins || null);
  const [abTestResult, setAbTestResult] = useState("");
  const indexRef = useRef(0);
  // const previewModal = useRef(null); // 查看大图弹窗
  const detailRef = useRef(null);
  // const [offsetTop, setOffsetTop] = useState(0);
  const [notFoundPin, setNotFountPin] = useState(false);

  const pinFile = useMemo(() => {
    return file || pin?.file;
  }, [file, pin]);
  const initRef = useRef(true);
  useMount(async () => {
    let result = await getExpsValue("hideGatherBtn", "string_0");
    setAbTestResult(result);
  }, []);
  useEffect(() => {
    if (pin?.extra && getContentType(pin?.extra === ContentType.material)) {
      stewardInstance.trigerAwaitInit(
        PRESETS_CONDITION.HUABAN_MATERIAL_DETAILS_ENTER_TIMES,
        {
          needRemoveTrigger: true,
        }
      );
    }
  }, [pin?.extra]);
  const { run: runReload } = useRequest(
    async () => {
      if (!pinId) {
        return;
      }

      // 服务端渲染第一次则没有必要重复请求数据
      if (initRef.current && initPins) {
        pvTracker(getPageData());
        initRef.current = false;
        return;
      }

      const result = await getPin({
        pin_id: pinId,
        pins: 20,
        ignoreMessage: true,
        related_topic: "material",
      });

      const pin = result?.pin || null;

      if (result.err === 404) {
        if (isModal) {
          setNotFountPin(true);
        } else {
          router.push("/404", `/pins/${pinId}`);
        }
      } else {
        setNotFountPin(false);
        setPin(pin);
        if (user) {
          addHistory({
            type: "pin",
            record: result?.pin,
            id: pinId,
          });
        }
      }
      // 区分素材采集还是普通采集需要等接口拿到数据后再报
      pvTracker(getPageData());
    },

    {
      refreshDeps: [pinId],
    }
  );

  const { runAsync: runDelete } = useRequest(deletePin, {
    manual: true,
  });
  const { runAsync: runLike } = useRequest(likePin, {
    manual: true,
  });
  const { runAsync: runUnlike } = useRequest(unlikePin, {
    manual: true,
  });

  useEffect(() => {
    if (pin) {
      window.dispatchEvent(new CustomEvent(EVENT.UPDATE_PIN, { detail: pin }));
    }
  }, [pin]);

  const onToggleLike = useCallback(async () => {
    if (!user) {
      const result = await login();
      if (!result) {
        return;
      }
    }
    if (!pin) {
      return;
    }
    if (pin?.liked) {
      const result = await runUnlike(pin.pin_id);
      if (!result.err) {
        setPin({
          ...pin,
          liked: false,
          like_count: pin.like_count - 1,
        });
      }
    } else {
      const result = await runLike(pin.pin_id);
      if (!result.err) {
        setPin({
          ...pin,
          liked: true,
          like_count: pin.like_count + 1,
        });
      }
    }
  }, [login, pin, runLike, runUnlike, user]);

  const onEdit = useCallback(() => {
    PinEditorModal.open({
      pinId: pin?.pin_id,
      onOk: () => {
        runReload();
      },
      onDelete: () => {
        if (isModal) {
          onClose && onClose();
          window.dispatchEvent(
            new CustomEvent(EVENT.DELETE_PIN, { detail: pin?.pin_id })
          );
        } else {
          router.push(`/boards/${pin?.board_id}`);
        }
      },
    });
  }, [isModal, onClose, pin, router, runReload]);

  const onPinSuccess = useCallback(() => {
    setPin({
      ...pin,
      repin_count: pin.repin_count + 1,
    });

    // 素材点击采集N次触发运营配置
    if (
      pin?.file_material?.status === 2 &&
      pin?.file_material?.material_category !== "其他" &&
      pin?.material_info &&
      pin?.material_info.err !== 404 &&
      !user?.vips?.length
    ) {
      stewardInstance.trigerAwaitInit(
        PRESETS_CONDITION.HUABAN_MATERIAL_COLLECT_TIMES
      );
    }
  }, [pin, user]);

  const onDelete = useCallback(() => {
    Modal.confirm({
      title: "删除采集",
      content: "确定要删除当前采集？",
      okText: "确定",
      cancelText: "取消",
      onOk: async () => {
        await runDelete({ pin_id: pin?.pin_id });
        HBMessage.success("删除成功");
        if (isModal) {
          onClose && onClose();
          window.dispatchEvent(
            new CustomEvent(EVENT.DELETE_PIN, { detail: pin?.pin_id })
          );
        } else {
          router.push(`/boards/${pin.board_id}`);
        }
      },
    });
  }, [isModal, onClose, pin, router, runDelete]);
  const getCurrentPreview = (pin, pinFile, user) => {
    const origin = user?.user_id === pin?.user_id || !pin?.link;
    let currentPreview = {
      src: imageUrl(pinFile, {
        webp: false,
        origin,
      }),
      preview: {
        width: !origin && pinFile.width > 1200 ? 1200 : pinFile.width,
        height:
          !origin && pinFile.width > 1200
            ? Math.floor((pinFile.height * 1200) / pinFile.width)
            : pinFile.height,
        src: imageUrl(pinFile, {
          width: window.devicePixelRatio > 1 ? 1200 : 658,
        }),
      },
      pinFile,
    };
    // 不支持的图片格式
    if (["image/tiff"].includes(pinFile?.type)) {
      currentPreview.src = `https://${pinFile.bucket}.huaban.com/${pinFile.key}?x-oss-process=image/format,png`;
      currentPreview.pinFile = { ...pinFile, type: "image/png" };
    }
    return currentPreview;
  };
  const onShowPreview = useCallback(() => {
    let currentPreview = getCurrentPreview(pin, pinFile, user);
    useAppStore.setState({ currentPreview });
    let detailsSetp = getNextDetailsSetp();
    let historyData = typeof history?.state === "object" ? history?.state : {};

    history.pushState(
      isModal
        ? {
            ...historyData,
            detailsSetp,
            viewImageSetp: 1,
            firstPinId: pin?.pin_id,
          }
        : { ...historyData },
      null,
      `/pins/${pin.pin_id}?modalImg=${encodeURIComponent(currentPreview.src)}`
    );
  }, [pin, pinFile, user, isModal]);

  const [prevPin, nextPin] = useMemo(() => {
    // 过滤折叠对象
    const pins = pinQueue.filter((item) => !item.folding_num);

    if (pins.length <= 0 || !pinId) {
      return [null, null];
    }
    let index = pins.findIndex((item) => item.pin_id == pinId);
    // 兼容画板的采集列表点击然后保留当前index位置
    if (index === -1) {
      index = indexRef.current;
    } else {
      indexRef.current = index;
    }

    return [pins[index - 1], pins[index + 1]];
  }, [pinQueue, pinId]);

  const onOperation = useCallback(
    (pin) => {
      // 下一张的时候判断当前查看大图弹窗是否打开
      let { modalImg } = qs.parse(location.search.slice(1));
      // 每次push的时候记录一下detailSetp
      let detailsSetp = getNextDetailsSetp();
      let viewImageSetp = getNextViewImageSetp();
      let historyData =
        typeof history?.state === "object" ? history?.state : {};
      if (modalImg) {
        let currentPreview = getCurrentPreview(pin, pin.file, user);
        useAppStore.setState({
          currentPin: { pinId: pin.pin_id },
          currentPreview,
        });
        window.history.pushState(
          isModal
            ? { ...historyData, detailsSetp, viewImageSetp }
            : { ...historyData },
          null,
          `/pins/${pin.pin_id}?modalImg=${encodeURIComponent(
            currentPreview.src
          )}`
        );
      } else {
        window.history.pushState(
          { ...historyData, detailsSetp },
          null,
          `/pins/${pin.pin_id}`
        );
        useAppStore.setState({ currentPin: { pinId: pin.pin_id } });
      }
    },
    [isModal, user]
  );

  // 快捷键：查看采集大图
  useKeyPress(
    SHORTCUT.FULL_IMAGE,
    () => {
      const editing = isEditingElement();
      if (editing) {
        return false;
      }
      let { modalImg } = qs.parse(location.search.slice(1));
      if (modalImg) {
        // 关闭
        // 重置currentPreview 数据
        useAppStore.setState({ currentPreview: {} });
        let detailsSetp = getNextDetailsSetp();
        let viewImageSetp = getNextViewImageSetp();
        // 判断用户有没有左右切换之后切换回原点
        let firstPinId = history?.state?.firstPinId;
        let historyData =
          typeof history?.state === "object" ? history?.state : {};
        // 修改当前url
        window.history.pushState(
          {
            ...historyData,
            detailsSetp,
            ...(location.pathname.includes(firstPinId)
              ? { viewImageSetp }
              : null),
          },
          null,
          `${location.pathname}`
        );
      } else {
        // 打开
        onShowPreview();
      }
    },
    {
      exactMatch: true,
    }
  );

  useKeyPress(
    SHORTCUT.EXIT,
    () => {
      const editing = isEditingElement();
      if (editing) {
        return false;
      }

      onClose && onClose();
    },
    {
      exactMatch: true,
    }
  );

  useKeyPress(
    SHORTCUT.SOURCE_URL,
    () => {
      const editing = isEditingElement();
      if (editing) {
        return false;
      }

      if (pin?.source && !pin?.domain?.hide_origin) {
        window.open(
          `/go?pin_id=${pin?.pin_id}&url=${encodeURIComponent(pin?.source)}`
        );
      }
    },
    {
      exactMatch: true,
    }
  );
  useKeyPress(
    SHORTCUT.DELETE_PIN,
    () => {
      const editing = isEditingElement();
      if (editing) {
        return false;
      }

      if (user?.user_id === pin?.user_id) {
        onDelete();
      }
    },
    {
      exactMatch: true,
    }
  );

  const onSelectPin = useCallback(
    (pin, currentSrc, source) => {
      const param = source ? `?from=${source}` : "";
      const pinId = pin.pin_id;
      if (pinOpenType === PIN_OPEN_TYPE.BLANK) {
        window.open(`/pins/${pinId}${param}`);
        return;
      }
      if (isModal) {
        // currentSrc用于渐进式显示图片，先显示缓存图，再显示大图
        useAppStore.setState({ currentPin: { pinId, currentSrc } });
        let detailsSetp = getNextDetailsSetp();
        let historyData =
          typeof history?.state === "object" ? history?.state : {};
        window.history.pushState(
          { ...historyData, detailsSetp },
          null,
          `/pins/${pinId}${param}`
        );
      } else {
        // 用于渐进式显示图片，先显示缓存图，再显示大图，但是这个router.push的方式所以只能把缓存图片地址通过window传递
        window._pinDetailCurrentSrc = currentSrc;
        router.push(`/pins/${pinId}${param}`);
      }
    },
    [isModal, pinOpenType, router]
  );

  // 推荐内容：同在画板 和 为你推荐
  const isVideo = useMemo(() => {
    let data = pin || currentPin;
    return (
      data?.file_material?.material_category === "视频模板" ||
      data?.file_material?.material_category === "视频"
    );
  }, [pin, currentPin]);
  const isGif = useMemo(() => {
    let data = pin || currentPin;
    return data?.file?.type === "image/gif";
  }, [pin, currentPin]);

  const onReport = useCallback(async () => {
    if (!user) {
      const result = await login();
      if (!result) {
        return;
      }
    }

    ReportModal.open({
      reportType: "采集",
      reportPinId: pin?.pin_id,
      reportContentId: pin?.file_material?.material_id,
      reportFileId: pin?.file_id,
      contentType: getContentType(pin?.extra),
      onOk: async (values) => {
        const result = await report({
          type: "pin",
          ...values,
          id: pin?.pin_id,
        });
        if (!result.err) {
          HBMessage.success(
            "谢谢你对花瓣的贡献，花瓣的工作人员会及时处理你的举报的"
          );
        } else {
          HBMessage.success("已收到您的举报信息，我们会尽快处理的");
        }
      },
    });
  }, [login, pin, user]);
  const hideGatherBtn = useMemo(() => {
    let result = pin || currentPin;
    return result?.extra?.material_id && abTestResult === "string_1";
  }, [pin, abTestResult, currentPin]);

  const isOffical = useMemo(() => {
    return config?.officialUsers?.split(",").includes(pin?.user?.urlname);
  }, [pin, config]);

  const isBigCompany = useMemo(() => {
    return isBigCompanyByUser(user);
  }, [user]);

  return (
    <div className={classNames([styles.detail, isModal ? styles.pt : null])}>
      <When condition={isModal}>
        <ModalOperate
          onClose={onClose}
          nextPin={nextPin}
          prevPin={prevPin}
          onOperation={onOperation}
        ></ModalOperate>
      </When>

      <If condition={notFoundPin && isModal}>
        {/* 没有找到采集，且在弹窗模式下 */}
        <Then>
          <div className={styles.notFound}>
            <HBEmpty
              image="//cdn.dancf.com/fe-assets/img/b6574f8d7ee91f21094691f3ff13d5a9.svg"
              title="Oh~抱歉，访问的采集不存在了"
              subtitle="采集有误或该采集已被删除"
            />
          </div>
        </Then>

        <Else>
          <PinHead pin={pin}></PinHead>
          <div
            id="pin_detail"
            className={styles.card}
            ref={detailRef}
            data-content-source="采集详情"
            data-content-id={pin?.pin_id}
            data-board-id={pin?.board_id}
            data-material-id={pin?.extra?.material_id}
            data-file-id={pin?.file_id}
            data-content-type={getContentType(pin?.extra)}
          >
            <div className={classNames([styles.img, styles.leftImg])}>
              <Switch>
                <Case condition={isVideo}>
                  <div
                    className={styles.viewer}
                    data-gd-expose="content_expose"
                    data-content-id={pin?.pin_id}
                  >
                    <div
                      className={styles.viewerWrap}
                      // style={{
                      //   maxHeight: `calc(100vh - ${offsetTop}px)`,
                      //   minHeight:
                      //     (pinFile?.height * Math.min(pinFile?.width, 658)) /
                      //     pinFile?.width,
                      // }}
                    >
                      <div
                        className={classNames([
                          styles.viewContent,
                          styles.white,
                        ])}
                      >
                        <video
                          src={pin?.file_material?.extra?.video_mask}
                          style={{ top: isModal ? 24 : headerHeight + 24 }}
                          controls
                          loop
                          muted
                          autoPlay
                          preload="metadata"
                          controlsList="nodownload"
                        />
                      </div>
                    </div>
                  </div>
                </Case>
                <Case condition={pinFile}>
                  <div
                    className={classNames([styles.viewer, styles.zoom])}
                    onClick={onShowPreview}
                    data-gd-expose="content_expose"
                    data-content-id={pin?.pin_id}
                    data-gd-click="button_click"
                    data-button-name="查看大图"
                  >
                    <div
                      className={styles.viewerWrap}
                      // style={{
                      //   maxHeight: `calc(100vh - ${offsetTop}px)`,
                      //   minHeight:
                      //     (pinFile?.height * Math.min(pinFile?.width, 658)) /
                      //     pinFile?.width,
                      // }}
                    >
                      <div
                        className={styles.viewContent}
                        style={{
                          top: isModal ? 24 : headerHeight + 24,
                          height:
                            (pinFile?.height * Math.min(pinFile?.width, 658)) /
                            pinFile?.width,
                        }}
                      >
                        <Image
                          className={classNames([
                            "transparent-img-bg",
                            Math.min(pinFile?.width, 658) === 658
                              ? styles.radius
                              : null,
                          ])}
                          preClassName={styles.pre}
                          key={imageUrl(pinFile, { width: 658 })}
                          src={imageUrl(pinFile, { width: 658 })}
                          srcSet={imageUrl(pinFile, { width: 1200 }) + " 2x"}
                          preSrc={currentSrc}
                          alt={
                            pin?.raw_text ||
                            `${pin?.board?.title}内的花瓣采集图片-${pin?.user?.username}`
                          }
                          width={Math.min(pinFile?.width, 658)}
                          height={
                            (pinFile?.height * Math.min(pinFile?.width, 658)) /
                            pinFile?.width
                          }
                          loading={"eager"}
                          title="点击查看大图 [F]"
                          limit={true}
                          showError={true}
                          fetchpriority={"high"}
                        />
                      </div>
                    </div>
                  </div>

                  {/* 相似采集按钮 */}
                  <Affix
                    target={() =>
                      isModal
                        ? document.querySelector(".pinDetailModal")
                        : window
                    }
                    offsetBottom={8}
                    style={{
                      position: "absolute",
                      bottom: "32px",
                      left: "32px",
                    }}
                  >
                    <Button
                      className={classNames(styles.link, styles.similarLink)}
                      data-gd-click="button_click"
                      data-button-name="搜索相似采集"
                      href={`/pins/${pin?.pin_id}/similar`}
                      target="_blank"
                      rel="nofollow"
                      data-tooltip="搜相似"
                    >
                      <HBIcon type="ic_search-similar1" />
                    </Button>
                  </Affix>
                </Case>
              </Switch>
              <When condition={pin?.source && !pin?.domain?.hide_origin}>
                <Affix
                  target={() =>
                    isModal ? document.querySelector(".pinDetailModal") : window
                  }
                  offsetBottom={8}
                  style={{
                    position: "absolute",
                    bottom: "32px",
                    right: "12px",
                  }}
                >
                  <a
                    className={styles.link}
                    title={pin?.link}
                    target="_blank"
                    href={`/go?pin_id=${pin?.pin_id}&url=${encodeURIComponent(
                      pin?.source
                    )}`}
                    rel="noreferrer"
                  >
                    <HBIcon className={styles.icon} type="ic_link" />
                    <span className={styles.text}>{pin?.link}</span>
                  </a>
                </Affix>
              </When>
            </div>
            <div className={styles.info}>
              <div
                className={styles.action}
                style={{ top: isModal ? 0 : headerHeight }}
              >
                <div className={styles.left}>
                  <ShareDropdown
                    placement="bottomCenter"
                    pics={imageUrl(pinFile)}
                    title="这张来自「花瓣网」的图不错哦，快来看看！"
                  >
                    <div
                      className={styles.share}
                      data-gd-click="button_click"
                      data-button-name="分享"
                    >
                      <HBIcon type="ic_share" />
                    </div>
                  </ShareDropdown>
                  <div
                    className={styles.report}
                    onClick={onReport}
                    title="举报"
                    data-gd-click="button_click"
                    data-button-name="举报"
                    data-report-type="采集"
                    data-report-pin-id={pin?.pin_id}
                    data-report-file-id={pin?.file_id}
                    data-report-content-id={pin?.file_material?.material_id}
                    data-tooltip="举报"
                    data-tooltip-position="bottom"
                  >
                    <HBIcon type="alert" />
                  </div>
                </div>
                <div className={styles.right}>
                  <If condition={user?.user_id === pin?.user_id}>
                    <Then>
                      <Button
                        className={styles.delete}
                        type="text"
                        onClick={onDelete}
                        data-gd-click="button_click"
                        data-button-name="删除"
                      >
                        <HBIcon type="ic_delete" />
                      </Button>
                      <Button
                        className={styles.edit}
                        type="text"
                        onClick={onEdit}
                        data-gd-click="button_click"
                        data-button-name="编辑"
                      >
                        <HBIcon type="ic_edit" />
                      </Button>
                    </Then>
                    <Else>
                      <Button
                        className={classNames([
                          styles.favour,
                          pin?.liked ? styles.active : null,
                        ])}
                        type="text"
                        onClick={onToggleLike}
                        data-gd-click="button_click"
                        data-button-name={pin?.liked ? "取消喜欢" : "喜欢"}
                        data-tooltip={pin?.liked ? "取消喜欢" : "喜欢"}
                        data-tooltip-position="bottom"
                      >
                        <HBIcon
                          type={pin?.liked ? "ic_favorite" : "favorite"}
                        />
                      </Button>
                    </Else>
                  </If>

                  <div
                    className={classNames({
                      [styles.hidden]: hideGatherBtn,
                    })}
                  >
                    <UserGuideTooltip
                      needUserId={false}
                      visible={userReady && !user}
                      title={
                        <div>
                          <div className={styles.tipTitle}>
                            点采集，可以收藏图片哦
                          </div>
                          <div>
                            创建你的在线灵感图库，创作时候能随时随地翻看，提高创作效率
                          </div>
                        </div>
                      }
                      containerClassName={styles.tipContent}
                      localStorageKey={() => "hb_new_user_pin_btn_tooltip"}
                      placement="leftTop"
                    >
                      <PinButton
                        pin={pin}
                        onOk={onPinSuccess}
                        current={true}
                        shortcutOrder={0}
                      />
                    </UserGuideTooltip>
                  </div>
                </div>
              </div>
              <PinTitle pin={pin || currentPin} setPin={setPin}></PinTitle>

              <Switch>
                <Case
                  condition={
                    pin?.file_material?.status === 2 &&
                    pin?.file_material?.material_category !== "其他" &&
                    pin?.material_info &&
                    pin?.material_info.err !== 404
                  }
                >
                  <PinMaterial pin={pin} />
                </Case>
                <Case condition={pin?.file_material?.status === 6}>
                  <PinMaterialRedirect pin={pin} />
                </Case>
                <Case condition={pin?.file_aigc}>
                  <PinAIInfo info={pin?.file_aigc} pin={pin} />
                </Case>
              </Switch>

              {!isVideo &&
                !isGif &&
                !isBigCompany &&
                (pin?.pin_id || pinId) && (
                  <SimilarMaterialList
                    material_id={pin?.extra?.material_id}
                    className={styles.similar}
                    pin_id={pin?.pin_id || pinId}
                    onSelect={onSelectPin}
                    initList={similarMaterials}
                  />
                )}
              {/* 素材展示主题，其他展示画板 */}
              {pin?.related_topic && isOffical && !isBigCompany ? (
                <PinTopic data={pin} isModal={isModal} />
              ) : (
                <Board data={pin} setPin={setPin} isModal={isModal} />
              )}
              {/* 用户头像模块 */}
              <User pin={pin || currentPin} setPin={setPin}></User>

              <div className={styles.amount}>
                转采 {displayNum(pin?.repin_count) || 0} · 喜欢{" "}
                {displayNum(pin?.like_count) || 0}
              </div>
            </div>
          </div>
          {/* 推荐 */}
          <Recommend
            isModal={isModal}
            pin={pin}
            relatedBoards={relatedBoards}
          />
        </Else>
      </If>
    </div>
  );
}
